import {FC, Suspense, lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {MenuTestPage} from '../pages/MenuTestPage'
import ChangePsw from '../modules/settings/change-psw/ChangePassword'
import AuditPage from '../modules/settings/auditlog/AuditPage'
import LogoutUser from 'src/_metronic/layout/LogoutUser'
import DashboardComponent from 'src/app/pages/Dashboard'
import PartyPage from '../modules/manage-party/PartyPage'
import PartyEntryPage from '../modules/party-entry/PartyEntryPage'
import PartyLedgerPage from '../modules/report/party-ledger/PartyLedgerPage'
import TransactionsPage from '../modules/report/transactions/TransactionsPage'
import DeletedTransactionsPage from '../modules/report/deleted-transactions/DeletedTransactionsPage'
import RecalculatePage from '../modules/report/recalculate/RecalculatePage'
import CitywiseClosingReports from '../modules/report/citywise_closing_reports/CityWiseReportCity'
import CityWiseReportPage from '../modules/report/citywise_closing_reports/CityWiseReportPage'

const PrivateRoutes = () => {
  const MessagePage = lazy(() => import('../modules/messages/MessagePage'))
  const UserPage = lazy(() => import('../modules/users/UserPage'))
  const GeneralLedgerPage = lazy(
    () => import('../modules/report/generalledger/GeneralLedgerReport')
  )
  const CustomerLedgerPage = lazy(
    () => import('../modules/report/customerledger/CustomerLedgerPage')
  )
  const ImportExportPage = lazy(() => import('../modules/import-excel/ImportExcelPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Message Listing after success login */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route
          path='dashboard'
          element={
            <SuspensedView>
             <DashboardComponent/>
            </SuspensedView>
          }
        />
        {/* Lazy Modules */}
        <Route
          path='partys/*'
          element={
            <SuspensedView>
              <PartyPage />
            </SuspensedView>
          }
        />

        <Route
          path='party-entry/*'
          element={
            <SuspensedView>
              <PartyEntryPage />
            </SuspensedView>
          }
        />

        <Route
          path='report/*'
          element={
            <SuspensedView>
              <PartyLedgerPage />
              <GeneralLedgerPage />
              <TransactionsPage />
              <DeletedTransactionsPage />
              <RecalculatePage />
              <CityWiseReportPage />
            </SuspensedView>
          }
        />

        {/* <Route
          path='message/*'
          element={
            <SuspensedView>
              <MessagePage />
            </SuspensedView>
          }
        /> */}

        <Route
          path='user/*'
          element={
            <SuspensedView>
              <UserPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='import-excel/*'
          element={
            <SuspensedView>
              <ImportExportPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='change-password'
          element={
            <SuspensedView>
              <ChangePsw />
            </SuspensedView>
          }
        />

        {/* <Route
          path='settings/audit-log*'
          element={
            <SuspensedView>
              <AuditLog />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='settings/auditlog/*'
          element={
            <SuspensedView>
              <AuditPage />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='report/supportticketarchive/*'
          element={
            <SuspensedView>
              <SupportticketarchiveReport />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='report/claimarchive/*'
          element={
            <SuspensedView>
              <ClaimarchivesPage />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='report/sentreceiveparts/*'
          element={
            <SuspensedView>
              <SentReceivepartsPage />
            </SuspensedView>
          }
        /> */}

        <Route
          path='report/generalledger/*'
          element={
            <SuspensedView>
              <GeneralLedgerPage />
            </SuspensedView>
          }
        />

        <Route
          path='partyledger/*'
          element={
            <SuspensedView>
              <CustomerLedgerPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='report/recalculate-ledger/*'
          element={
            <SuspensedView>
              <RecalculateLedgerPage />
            </SuspensedView>
          }
        /> */}

        <Route
          path='logout-user'
          element={
            <SuspensedView>
              <LogoutUser />
            </SuspensedView>
          }
        />

        {/* <Route path='report/citywise-closing-reports' element={<CitywiseClosingReports />} /> */}

        {/* <Route
          path='report/pendingtoreceivefromservicecenter/*'
          element={
            <SuspensedView>
              <PendingToReceivePartsPage />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='report/supportticketsanalysisbytickettype/*'
          element={
            <SuspensedView>
              <SupportticketanalysisReport />
            </SuspensedView>
          }
        /> */}

        {/* <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
